import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';

import {LINES_DATA, MobileLineState} from './interface';
import actions from './mobileLinesAction';
import {RootState} from '../../app/store';

const initialState: MobileLineState = {
	isLoad:      false,
	data:        [],
	isLoadUsage: false
};

export const getMobileLineApi = createAsyncThunk('mobileLine/getMobileLineApi', actions.getMobileLinesApi);

export const getMobileLinesUsageApi = createAsyncThunk(
	'mobileLines/getMobileLinesUsageApi',
	async (_: void, {getState, dispatch}) => {
		const state = getState() as RootState;
		const user = state.user.data;
		const lines = state.mobileLines.data.filter(line => line.lineData?.status === 'used');

		const concurrency = 2;
		const flushSize = 10; // <- dispatch groupé toutes les 10 réponses reçues

		let index = 0;
		let buffer: {phoneNumber: string, serial: string; usage: LINES_DATA['usage']}[] = [];

		const flush = () => {
			if (!buffer.length)
				return;

			dispatch(Reducer.actions.setLinesUsage(buffer));
			buffer = [];
		};

		const worker = async () => {
			while (index < lines.length) {
				const line = lines[index];
				index += 1;

				const usage: LINES_DATA['usage'] = await actions.getMobileLinesUsageApi(line.phoneNumber, line.serial, user);

				buffer.push({phoneNumber: line.phoneNumber, serial: line.serial, usage});

				if (buffer.length >= flushSize)
					flush();
			}
		};

		await Promise.all(Array.from({length: concurrency}, worker));

		flush();
	},
	{
		condition: (_, {getState}) => {
			const state = getState() as RootState;

			if (state.mobileLines.isLoadUsage)
				return false;
		}
	}
);

export const Reducer = createSlice({
	initialState,
	name:     'mobileLine',
	reducers: {
		setLinesUsage: (state, action: PayloadAction<{phoneNumber: string; serial: string; usage: LINES_DATA['usage']}[]>) => {
			action.payload.forEach(({phoneNumber, serial, usage}) => {
				const line = state.data.find(l => l.phoneNumber === phoneNumber && l.serial === serial);

				if (line?.lineData)
					line.lineData.usage = usage;
			});
		}
	},

	extraReducers: (builder) => {
		builder
		.addCase(getMobileLineApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getMobileLineApi.fulfilled, (state, action) => {
			state.isLoad = false;
			state.data = action.payload;
		})

		.addCase(getMobileLinesUsageApi.pending, (state) => {
			state.isLoadUsage = true;
		})
		.addCase(getMobileLinesUsageApi.fulfilled, (state) => {
			state.isLoadUsage = false;
		})
		.addCase(getMobileLinesUsageApi.rejected, (state) => {
			state.isLoadUsage = false;
		});
	}
});

export default Reducer.reducer;